import { FaTrash } from "react-icons/fa";

export default function PedidoDetalleItem({
  detalle,
  index,
  productos,
  onUpdate,
  onDelete,
  onBuscar,
  onSelectProducto,
}) {
  return (
    <div className="relative rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900/70 p-3 space-y-2">
      {/* Buscar producto */}
      <div className="relative">
        <input
          type="text"
          placeholder="Buscar producto…"
          value={detalle.busqueda}
          onChange={(e) => onBuscar(index, e.target.value)}
          autoComplete="off"
          className="w-full rounded-lg border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 px-3 py-2 text-sm focus:ring-2 focus:ring-amber-400"
        />

        {detalle.sugerencias?.length > 0 && (
          <ul className="absolute z-20 mt-1 w-full max-h-40 overflow-y-auto rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 shadow-lg text-sm">
            {detalle.sugerencias.map((p) => (
              <li
                key={p.id}
                onClick={() => onSelectProducto(index, p)}
                className={`px-3 py-2 cursor-pointer flex justify-between gap-2
                  hover:bg-slate-100 dark:hover:bg-slate-800
                  ${p.bloqueado ? "opacity-60" : ""}
                `}
              >
                <span>
                  {p.nombre}
                  {p.bloqueado && (
                    <span className="ml-1 text-[11px] text-rose-500">
                      (sin stock)
                    </span>
                  )}
                </span>
                <span className="text-slate-500">
                  ${p.precio.toFixed(2)}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Cantidad y precio */}
      <div className="grid grid-cols-2 gap-2">
        <input
          type="number"
          min="1"
          value={detalle.cantidad}
          onChange={(e) =>
            onUpdate(index, "cantidad", e.target.value)
          }
          className="rounded-lg border border-slate-300 dark:border-slate-600 px-3 py-2 text-sm"
        />

        <input
          type="number"
          step="0.01"
          value={detalle.precio}
          onChange={(e) =>
            onUpdate(index, "precio", e.target.value)
          }
          className="rounded-lg border border-slate-300 dark:border-slate-600 px-3 py-2 text-sm"
        />
      </div>

      {/* Descripción + acciones */}
      <div className="flex items-center gap-2">
        <input
          type="text"
          placeholder="Observación del producto"
          value={detalle.descripcion}
          onChange={(e) =>
            onUpdate(index, "descripcion", e.target.value)
          }
          className="flex-1 rounded-lg border border-slate-300 dark:border-slate-600 px-3 py-2 text-sm"
        />

        <button
          type="button"
          onClick={() => onDelete(index)}
          className="w-10 h-10 rounded-full border border-red-500 text-red-500 hover:bg-red-500 hover:text-white transition"
        >
          <FaTrash />
        </button>
      </div>

      {/* Subtotal */}
      <div className="text-right text-sm font-semibold text-emerald-400">
        Subtotal: ${Number(detalle.subtotal || 0).toFixed(2)}
      </div>
    </div>
  );
}
